// Erkennung der Verknüpfungs-Marker des Servers (Substring-Vertrag wie in handleErrors.ts und
// sharedLoginError.ts): die Bucher-Resolver wickeln jeden Fehler in einen Text, nur der Marker
// kommt an. Die Strings stammen aus dem shared-Baum, Server und Client importieren dieselben.
import {LINK_ACCOUNT_ALREADY_LINKED, LINK_CONFIRMATION_REQUIRED, LINK_FORBIDDEN, LINK_RANK_TOO_HIGH} from "../../../../shared/models/bookerLinkErrors";

const messagesOf = (err: unknown): Array<string> => {
    if (!err || typeof err !== "object") return [];
    const anyErr = err as {message?: unknown; graphQLErrors?: Array<{message?: unknown}>};
    const gql = Array.isArray(anyErr.graphQLErrors) ? anyErr.graphQLErrors.map((e) => e?.message) : [];

    return [anyErr.message, ...gql].filter((message): message is string => typeof message === "string");
};

const includesMarker = (err: unknown, marker: string): boolean => messagesOf(err).some((message) => message.includes(marker));

/** Zielkonto ist ein Mitarbeiter-Login: Dialog zeigen und mit `linkExistingAccountConfirmed: true` erneut senden. */
export const isLinkConfirmationRequiredError = (err: unknown): boolean => includesMarker(err, LINK_CONFIRMATION_REQUIRED);

export const isLinkRankTooHighError = (err: unknown): boolean => includesMarker(err, LINK_RANK_TOO_HIGH);

export const isLinkForbiddenError = (err: unknown): boolean => includesMarker(err, LINK_FORBIDDEN);

/** ID des Buchers, der bereits mit dem Zielkonto verknüpft ist (`[linkAccount]accountAlreadyLinked:<id>`), sonst `undefined`. */
export const linkedBookerIdOf = (err: unknown): string | undefined => {
    for (const message of messagesOf(err)) {
        const index = message.indexOf(LINK_ACCOUNT_ALREADY_LINKED);

        if (index !== -1) {
            const match = /^:([\w-]+)/.exec(message.slice(index + LINK_ACCOUNT_ALREADY_LINKED.length));

            return match ? match[1] : "";
        }
    }

    return undefined;
};

export const isAccountAlreadyLinkedError = (err: unknown): boolean => linkedBookerIdOf(err) !== undefined;

/** Der Admin hat den Dialog „Zugang verknüpfen“ abgebrochen: nichts wurde gespeichert, kein Fehlermodal. */
export class LinkAccountCancelledError extends Error {
    constructor() {
        super("link account cancelled");
        this.name = "LinkAccountCancelledError";
        Object.setPrototypeOf(this, LinkAccountCancelledError.prototype);
    }
}
